<template>

    <div
        class="mx-auto bg-gray-600 flex flex-nowrap whitespace-nowrap px-4 sm:px-6 lg:px-8 h-10 space-x-8"
    >
        <NavLink
            v-if="this.$page.props.auth.permissions.fiat.currencies"
            :href="route('fiat.currencies')"
            :active="route().current('fiat.currencies')"
        >
            Список валют
        </NavLink>
        <NavLink
            v-if="this.$page.props.auth.permissions.fiat.gateways"
            :href="route('fiat.gateways')"
            :active="route().current('fiat.gateways')"
        >
            Все шлюзы
        </NavLink>
        <NavLink
            v-if="this.$page.props.auth.permissions.fiat.gateway_edit && gateway"
            :href="route('fiat.gateway', gateway.id)"
            :active="route().current('fiat.gateway', gateway.id)"
        >
            Шлюз
        </NavLink>
        <NavLink
            v-if="this.$page.props.auth.permissions.fiat.credentials && gateway"
            :href="route('fiat.gateway.credentials', gateway.id)"
            :active="route().current('fiat.gateway.credentials', gateway.id)"
        >
            Реквизиты
        </NavLink>
        <NavLink
            v-if="this.$page.props.auth.permissions.fiat.credentials && gateway"
            :href="route('fiat.gateway.fields', gateway.id)"
            :active="route().current('fiat.gateway.fields', gateway.id)"
        >
            Поля
        </NavLink>
    </div>
</template>

<script>
import NavLink from "@/Components/NavLink";
import VNavLink from "@/Components/NavLink.vue";

export default {
    components: {
        VNavLink,
        NavLink,
    },
    props: {
        gateway: Object,
    },
}
</script>
